'use strict';

(function () {
  angular
    .module('specsguardApp')
    .config(module);

  module.$inject = ['$stateProvider'];

  function module ($stateProvider) {
    $stateProvider.state('module', {
      url: '/module',
      templateUrl: 'app-legacy/module/module.html',
      controller: 'ModuleCtrl',
      menu: {
        context: 'textual_template',
        title: '[Textual_templates]',
        subtitle: '[Modules]',
        icon: 'folder_empty'
      },
      authenticate: true,
      resolve: {
        moduleList: ['Module', function (Module) {
          return Module.get({withElements: true}).$promise;
        }]
      }
    }
    );
  }
})();
